<template>
  <app-dialog
    v-model="openModel"
    content-class="dialogWeb"
    @onClose="$emit('onClose')"
  >
    <!-- ★★★ この div に class="show-login" を追加するとログイン画面が表示されます ★★★ -->
    <div id="dialog-content-wrapper">
      <h1 class="dialogWeb-title mb20 content-recruitment-closed">
        現在募集期間外のため、ご利用いただけません。
      </h1>
      <v-card class="content-recruitment-closed">
        <v-card-text class="dialogWeb-content">
          <!-- p class="TextStyle1 TextIndent mb0">※次回のWEB募集は2026年3月中旬頃となります。</p>
            <p class="TextStyle1 TextIndent">※募集期間外でも保険の相談を受け付けています。詳細は以下のバナーよりご確認ください。</p>
            <p class="alignCenter mb0"><a href="https://www.hitachi-hoken.co.jp/service/check.html"><img src="/common/images/asset/bnr_n_check.png" width="300"></a></p -->
          <p class="TextStyle1 TextIndent mb0">
            ※次回の募集期間は<a href="/lp/seido/index.html#period"
              >制度保険のご案内ページ</a
            >をご確認ください。
          </p>
          <p class="TextStyle1 TextIndent">
            ※募集期間外でも保険に関するご相談を承っております。詳細は以下のバナーよりご確認ください。
          </p>
          <p class="alignCenter mb0">
            <a href="https://www.hitachi-hoken.co.jp/service/check.html"
              ><img src="/common/images/asset/bnr_n_check.png" width="300"
            /></a>
          </p>
        </v-card-text>
      </v-card>

      <h1 class="dialogWeb-title content-login">WEB募集ログイン</h1>
      <v-card class="content-login">
        <v-card-text class="dialogWeb-content">
          <div id="webRecruitment" class="modalStyle">
            <div id="radioBoxWeb" class="radiobox mb15">
              <input
                id="radio1"
                class="radiobutton"
                name="radioWebR"
                type="radio"
                value="radioWebR1"
                @change.prevent.stop="handleRadioSelect()"
              />
              <label for="radio1" class="green"
                >案内メールが<br />届いた方は<br
                  class="RWD_Show579"
                />こちら</label
              >
              <input
                id="radio2"
                class="radiobutton"
                name="radioWebR"
                type="radio"
                value="radioWebR2"
                @change.prevent.stop="handleRadioSelect()"
              />
              <label for="radio2" class="blue"
                >ログインIDカード<br />をお持ちの方<br
                  class="RWD_Show579"
                />はこちら</label
              >
            </div>

            <div id="step2" ref="step2">
              <p class="TextStyle1 mb10 CenterAdjust">
                <strong>
                  WEB募集はお客さまページ経由でも<br
                    class="RWD_Show579"
                  />ご利用いただけます。</strong
                >
              </p>
              <div class="checkBoxMyPageArea CenterAdjust">
                <input
                  id="checkMypage"
                  ref="checkMypage"
                  type="checkbox"
                  name="checkMypage"
                  @click="checkBoxMypage"
                />
                <label for="checkMypage">
                  お客さまページもあわせて登録する</label
                >
              </div>
              <ul class="LinkListStyle2 mb20">
                <li class="alignRight NewWin">
                  <a target="_blank" href="/mypage/mypage_LP.html"
                    >お客さまページについて詳細はこちら</a
                  >
                </li>
              </ul>

              <div id="boxLogin" ref="boxLogin">
                <ul
                  id="btnInfoMail"
                  ref="btnInfoMail"
                  class="ButtonStyle1 linkbox"
                >
                  <li>
                    <a
                      href="https://www.hitachi-hoken.com/Mypage/WB/PWBW0010.aspx"
                      class="pt15 pb15 mb0"
                      target="_blank"
                      rel="noopener noreferrer"
                      >WEB募集ログイン</a
                    >
                  </li>
                </ul>
                <ul
                  id="btnLoginID"
                  ref="btnLoginID"
                  class="ButtonStyle1 linkbox"
                >
                  <li>
                    <a
                      href="https://www2.hitachi-hoken.com/Mypage/WB/PWBW0010.aspx"
                      class="pt15 pb15 mb0"
                      target="_blank"
                      rel="noopener noreferrer"
                      >WEB募集ログイン</a
                    >
                  </li>
                </ul>
              </div>

              <div id="boxConfirm" ref="boxConfirm">
                <p class="TextStyle1 mb5 CenterAdjust">利用規約について</p>
                <div
                  id="MypageTerms"
                  ref="mypageTerms"
                  class="boxConfirmText mb20"
                  v-html="mypageTerms"
                ></div>
                <ul class="ButtonStyle1 linkbox mb0 CenterAdjust">
                  <li id="btnMypage1" ref="btnMypage1">
                    <a
                      href="https://www.hitachi-hoken.com/Mypage/WB/PWBW0010.aspx"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="mb0"
                      >同意してお客さまページ<br />新規登録へ進む</a
                    >
                  </li>
                </ul>
                <ul class="ButtonStyle1 linkbox mb0 CenterAdjust">
                  <li id="btnMypage2" ref="btnMypage2">
                    <a
                      href="https://www2.hitachi-hoken.com/Mypage/WB/PWBW0010.aspx"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="mb0"
                      >同意してお客さまページ<br />新規登録へ進む</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <!-- ★★★ ラッパー終了 ★★★ -->
  </app-dialog>
</template>

<script>
var step1, step1val;

export default {
  name: 'DialogWeb',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mypageTerms: '',
    };
  },
  computed: {
    openModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    showLogin() {
      return this.$store.getters['dialog/webShowLogin'];
    },
  },
  mounted() {
    const wrapper = document.getElementById('dialog-content-wrapper');
    if (wrapper && this.showLogin === true) {
      wrapper.classList.add('show-login');
    }

    var step2 = this.$refs.step2;
    if (!step2) {
      return false;
    } else {
      step2.style.display = 'none';
      this.$refs.boxLogin.style.display = 'none';
      this.$refs.btnInfoMail.style.display = 'none';
      this.$refs.btnLoginID.style.display = 'none';
      this.$refs.boxConfirm.style.display = 'none';
      this.$refs.btnMypage1.style.display = 'none';
      this.$refs.btnMypage2.style.display = 'none';
    }
  },
  methods: {
    handleRadioSelect() {
      var radioWebRs = document.getElementsByName('radioWebR');
      for (var i = 0; i < radioWebRs.length; i++) {
        if (radioWebRs[i].checked) {
          this.$refs.step2.style.display = 'block';

          if (radioWebRs[0].checked) {
            step1 = 0;
            step1val = step1;
            this.btnCheck();
            this.checkBoxMypage();
          } else if (radioWebRs[1].checked) {
            step1 = 1;
            step1val = step1;
            this.btnCheck();
            this.checkBoxMypage();
          } else {
            break;
          }

          break;
        }
      }
    },
    btnCheck() {
      this.$refs.boxLogin.style.display = 'block';

      if (step1val == 0) {
        this.$refs.boxLogin.style.display = 'block';
        this.$refs.btnInfoMail.style.display = 'block';
        this.$refs.btnLoginID.style.display = 'none';
        this.$refs.btnMypage1.style.display = 'block';
        this.$refs.btnMypage2.style.display = 'none';
      } else if (step1val == 1) {
        this.$refs.btnInfoMail.style.display = 'none';
        this.$refs.btnLoginID.style.display = 'block';
        this.$refs.btnMypage1.style.display = 'none';
        this.$refs.btnMypage2.style.display = 'block';
      }
    },
    checkBoxMypage() {
      if (this.$refs.checkMypage.checked) {
        this.$refs.boxLogin.style.display = 'none';
        this.$refs.boxConfirm.style.display = 'block';
        this.loadMyPageTerms();
      } else {
        this.$refs.boxLogin.style.display = 'block';
        this.$refs.boxConfirm.style.display = 'none';
      }
    },
    loadMyPageTerms() {
      var xhr = new XMLHttpRequest();
      xhr.open('get', '/MypageTerms.txt');
      xhr.overrideMimeType('text/plain; charset=Shift_JIS');
      xhr.send();

      xhr.addEventListener(
        'load',
        () => {
          this.mypageTerms = xhr.response;
        },
        false
      );
    },
  },
};
</script>

<style lang="scss">
.dialogWeb {
  max-width: 500px;
  width: calc(100% - 30px);

  &.modal-content {
    border: 0;
    border-radius: 10px !important;
    padding: 20px 30px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    font-family: 'Hitachi Sans', 'Noto Sans JP', 'Yu Gothic UI', 'Noto Sans',
      sans-serif;
    -webkit-font-smoothing: auto;
    -moz-osx-font-smoothing: auto;
    overflow: visible;
  }

  .v-sheet.v-card {
    box-shadow: none;
  }

  &-content {
    &.v-card__text {
      padding: 0 30px 20px;
    }
  }

  &-title {
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #666;
    margin-top: 15px;
    margin-bottom: 5px;
    width: 100%;
  }

  ul {
    li {
      &::before {
        content: unset;
      }
    }
  }
  ol {
    li {
      &::before {
        content: unset;
      }
    }
  }

  @media screen and (max-width: 767px) {
    width: calc(100% - 30px);
  }
}

// コンテンツ切り替え設定
// デフォルト: 募集期間外を表示、ログインを非表示
// <div id="dialog-content-wrapper" class="show-login"> とするとログインが表示されます
#dialog-content-wrapper {
  .content-login {
    display: none !important;
  }

  &.show-login {
    .content-recruitment-closed {
      display: none !important;
    }

    .content-login {
      display: block !important;
    }

    .dialogWeb-title.content-login {
      position: relative;
      width: 100%;
      margin: 0 0 20px;
      padding-bottom: 0.5em;
      border-bottom: 1px solid #ff979d;
      color: #0c0c0c;
      font-size: 19.2px;
      font-weight: 700;
      line-height: 1.6;

      &::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 50%;
        width: 70px;
        height: 3px;
        background-color: #cc0000;
        transform: translateX(-50%);
      }
    }

    .dialogWeb-content.v-card__text {
      padding: 0;
    }

    .radiobox {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 0 0 15px !important;
    }

    .radiobutton {
      display: none;
    }

    .radiobox label {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80%;
      min-height: 60px;
      margin: 1em 10%;
      padding: 10px 0;
      border: 0 !important;
      border-radius: 5px;
      box-sizing: border-box;
      background-color: #d9d9d9 !important;
      background-image: url('/common/images/icon/icon_link_black.png');
      background-repeat: no-repeat;
      background-position: right center;
      background-size: auto 25px;
      color: #0c0c0c !important;
      font-size: 15px;
      font-weight: 400 !important;
      line-height: 1.3;
      text-align: center;
      cursor: pointer;
    }

    .radiobox label.green:hover,
    .radiobox label.blue:hover,
    .radiobutton:checked + label.green,
    .radiobutton:checked + label.blue {
      background-color: #cc0000 !important;
      color: #fff !important;
    }

    .radiobutton:checked + label::before {
      content: '選択中';
      position: absolute;
      top: -20px;
      right: 0;
      left: 0;
      width: auto;
      height: auto;
      border: 0;
      background-color: transparent;
      color: #cc0000;
      font-size: 12px;
      font-weight: 700;
      line-height: 1;
      text-align: center;
      white-space: nowrap;
      transform: none;
    }

    .radiobutton:not(:checked) + label::before {
      content: none;
    }

    .radiobox label.green .RWD_Show579,
    .radiobox label.blue .RWD_Show579 {
      display: none;
    }

    #step2 {
      margin-top: 0;
    }

    #step2 > .TextStyle1,
    .checkBoxMyPageArea,
    .LinkListStyle2 {
      display: none;
    }

    #boxLogin .ButtonStyle1 {
      display: flex;
      width: 100%;
      margin: 0;
      padding: 0;
      list-style: none;
    }

    #boxLogin .ButtonStyle1 li {
      width: 100%;
      margin: 0;
      padding: 0;
      text-align: center;
    }

    #boxLogin .ButtonStyle1 a {
      position: relative;
      display: inline-block;
      width: auto !important;
      min-width: 130px;
      max-width: none;
      min-height: 0;
      margin: 0 auto;
      padding: 15px 22px 15px 15px !important;
      border-radius: 5px;
      background-color: #cc0000 !important;
      background-image: url('/image/jp/r1/icon/icon_link_right_l_white_hd.gif');
      background-repeat: no-repeat;
      background-position: right center;
      background-size: 16px 16px;
      color: #fff !important;
      font-size: 15px;
      font-weight: 400;
      line-height: 1.3;
      text-align: center;
      text-decoration: none;
    }

    #boxLogin .ButtonStyle1 a:hover,
    #boxLogin .ButtonStyle1 a:active {
      padding-right: 24px !important;
      background-color: #7d0008 !important;
    }

    @media screen and (max-width: 767px) {
      width: calc(100% - 30px);

      .dialogWeb-content.v-card__text {
        padding: 0;
      }

      .dialogWeb-title.content-login {
        width: 100%;
        margin: 0 0 20px;
        font-size: 19.2px;
      }

      .radiobox {
        gap: 0;
      }

      .radiobox label {
        width: 80%;
        max-width: none;
        min-height: 60px;
        margin: 1em 10%;
        padding: 10px 0;
        font-size: 15px;
      }

      .radiobutton:checked + label::before {
        top: -20px;
        right: 0;
        width: auto;
        height: auto;
        font-size: 12px;
      }

      #boxLogin .ButtonStyle1 a {
        width: auto !important;
        min-width: 130px;
        max-width: none;
        min-height: 0;
        font-size: 15px;
      }
    }
  }
}
</style>
